/**
 * Feature Flags - Control which features are visible in the UI
 *
 * Set via Netlify environment variables:
 * - VITE_FEATURE_TPRM=true (enable TPRM/Contract management)
 * - VITE_FEATURE_VENDOR_RISK=true (enable Vendor Risk assessments)
 * - VITE_FEATURE_POLICY_GEN=true (enable AI Policy Generator)
 * - VITE_FEATURE_AI_AGENT=true (enable 74-tool AI Agent)
 * - VITE_FEATURE_PRIVACY_PORTAL=true (enable Privacy/GDPR portal)
 * - VITE_FEATURE_QUESTIONNAIRE=true (enable Questionnaire library)
 * - VITE_FEATURE_INVOICE_BILLING=true (enable invoice billing option)
 *
 * All default to false for simplified product positioning.
 * Can be enabled per-tenant later as upsells.
 */

const parseEnvBoolean = (value: string | undefined): boolean => {
  if (!value) return false
  return value.toLowerCase() === 'true' || value === '1'
}

export const featureFlags = {
  // TPRM / Contract Management
  tprm: parseEnvBoolean(import.meta.env.VITE_FEATURE_TPRM),

  // Vendor Risk Assessment
  vendorRisk: parseEnvBoolean(import.meta.env.VITE_FEATURE_VENDOR_RISK),

  // AI Policy Generator
  policyGenerator: parseEnvBoolean(import.meta.env.VITE_FEATURE_POLICY_GEN),

  // AI Agent (74 tools)
  aiAgent: parseEnvBoolean(import.meta.env.VITE_FEATURE_AI_AGENT),

  // Privacy Portal / GDPR DSR
  privacyPortal: parseEnvBoolean(import.meta.env.VITE_FEATURE_PRIVACY_PORTAL),

  // Questionnaire Library
  questionnaire: parseEnvBoolean(import.meta.env.VITE_FEATURE_QUESTIONNAIRE),

  // Invoice Billing
  invoiceBilling: parseEnvBoolean(import.meta.env.VITE_FEATURE_INVOICE_BILLING),

  // Agent Registry
  agentRegistry: parseEnvBoolean(import.meta.env.VITE_FEATURE_AGENT_REGISTRY),
} as const

// Helper to check if any advanced features are enabled
export const hasAdvancedFeatures = () => {
  return Object.values(featureFlags).some(flag => flag === true)
}

// Log feature flags on load (dev only)
if (import.meta.env.DEV) {
  console.log('[Feature Flags]', featureFlags)
}
